<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("orders") }}
      </h1>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("date range") }}</label>
          <generic-calendar
            type="date"
            :is_range="true"
            ref="generic_calendar"
            @selected="date_changed"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("source") }}</label>
          <div class="control">
            <div class="select">
              <select v-model="meta.source">
                <option
                  :value="source.url_name"
                  v-for="(source, sidx) in sources"
                >
                  {{ source.establishment }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="title is-5">{{ $t("orders summary") }}</div>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("total") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(itm, spidx) in products_summary" :key="spidx">
            <td>{{ itm.product }}</td>
            <td>{{ itm.total }}</td>
          </tr>
        </tbody>
      </table>
      <div class="title is-5">{{ $t("custom orders summary") }}</div>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("customization") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(itm, spidx) in customized_products_summary" :key="spidx">
            <td>
              {{ itm.quantity }} x {{ itm.product_name }} -
              {{ itm.size.toUpperCase() }}
            </td>
            <td>{{ itm.customization }}</td>
          </tr>
        </tbody>
      </table>
      <!-- </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  format_time,
  format_currency,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import { groupBy } from "lodash";

export default {
  name: "OrdersReport",
  components: { GenericTable, GenericCalendar },
  data() {
    let v = this;
    return {
      orders: [],
      sources: [],
      meta: {
        start_date: "",
        end_date: "",
        source: "",
      },
    };
  },
  computed: {
    total_sold() {
      let v = this;
      let total = v.sales.reduce((acc, sale) => {
        return acc + Number(sale.total);
      }, 0);
      return total;
    },
    products_summary() {
      let v = this;
      let summary = {};
      let all_products = v.orders
        .map((order) => {
          return order.tailoring_order_items;
        })
        .reduce((acc, items) => {
          return acc.concat(items);
        }, []);

      let grouped = groupBy(all_products, (prd) => {
        return `${prd.product_name} - ${prd.size.toUpperCase()}`;
      });

      summary = Object.keys(grouped)
        .map((key) => {
          return {
            product: key,
            total: grouped[key].reduce((acc, prd) => {
              return acc + Number(prd.quantity);
            }, 0),
          };
        })
        .sort((a, b) => {
          if (b.product > a.product) return -1;
          if (b.product < a.product) return 1;
          return 0;
        });

      return summary;
    },
    customized_products_summary() {
      let v = this;
      let summary = {};
      let all_products = v.orders
        .map((order) => {
          return order.tailoring_order_items;
        })
        .reduce((acc, items) => {
          return acc.concat(items);
        }, [])
        .filter((prd) => prd.customization)
        .sort((a, b) => {
          if (b.product_name > a.product_name) return -1;
          if (b.product_name < a.product_name) return 1;
          return 0;
        });

      return all_products;
    },
  },
  methods: {
    format_date_time,
    format_time,
    format_currency,
    query() {
      let v = this;
      get("/apis/order/date-range", v.meta)
        .then((r) => {
          v.orders = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    date_changed(date) {
      let v = this;
      v.meta.start_date = date.start_date;
      v.meta.end_date = date.end_date;
    },
  },
  mounted() {
    let v = this;

    get("/apis/order/sources", {})
      .then((r) => {
        v.sources = r;
      })
      .catch((error) => {
        error_message(error);
      });
  },
};
</script>

<style>
/* Add Bulma styles here */
</style>
